import React from 'react';
import './page-loader.scss';

const PageLoader = () => <div className="loading" />;

export default PageLoader;
